"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mark_1 = require("./mark");
class Link extends mark_1.Mark {
    constructor(href, title) {
        super('link');
        this.href = href;
        this.title = title;
    }
    toJSON() {
        const linkMark = {
            type: this.type,
            attrs: {
                href: this.href
            }
        };
        if (this.title) {
            linkMark.attrs.title = this.title;
        }
        return linkMark;
    }
}
exports.Link = Link;
//# sourceMappingURL=link.js.map